import type { DataManifest } from './dataTypes';

let cache: DataManifest | null = null;

export async function loadManifest(): Promise<DataManifest> {
  if (cache) return cache;
  const res = await fetch('/data-manifest.json', { cache: 'no-cache' });
  if (!res.ok) throw new Error('data-manifest.json yüklenemedi');
  cache = await res.json();
  return cache!;
}

// No static labels; fields are dynamic


